import React, { useState, useEffect, useContext } from 'react';
import { AsyncPaginate, wrapMenuList } from "react-select-async-paginate";
import { components } from 'react-select';
import Checkbox from '#/components/Checkbox/index';

import styles from './styles.module.css';
import { SelectedItemsContext } from '#/providers/selectedItemsProvider';

import { useTranslation } from "react-i18next";

let isGroupSelection = false;

const mapItemsToLabelValue = (content) => {
  if(content === null || content === undefined || content.length <= 0) return [];

  return content.map(c => {

    if(c.label && c.options) {
      
      c.options = c.options.map(c => {
        let value = c.value || c.id;
        let name = c.label || c.name || c.fantasyName || `Nome não encontrado, id=${value}`;

        return {
          label: name,
          value: value
        }
      });

      isGroupSelection = true;

      return c;
    }

    let value = c.value || c.id;
    let name = c.label || c.name || c.fantasyName || `Nome não encontrado, id=${value}`;

    return {
      label: name,
      value: value
    }
  });
}

const MenuList = wrapMenuList(props => {
  const values = props.hasValue ? props.getValue() : [];
  const { onRemovedSelectedOption } = useContext(SelectedItemsContext);

  const { t } = useTranslation();


  return (
    <components.MenuList {...props}>
      {
        values.length <= 0 ? null :
          <div className={styles.multiSelect}>
            <h1 className={styles.filterTitle}>{t('SAVED_FILTERS')}</h1>
            {values.map(val => {
              return <div key={val.value} onClick={() => onRemovedSelectedOption(val) }>
                      <Checkbox id={val.value} label={val.label} isChecked={true} callBack={() => {/**/}} />
                    </div>
            })}
          </div>
      }
      {props.children}
    </components.MenuList>
  );
});

const customStyles = {
  menuList: (provided, state) => ({
    ...provided,
    padding: '0px',
    margin: '0px',
    borderTop: '1px solid #707070',
    borderLeft: '1px solid #707070',
    borderRight: '1px solid #707070',
    borderBottom: '1px solid #707070',
  }),
  control: (provided, state) => ({
    ...provided,
    boxShadow: 'none',
    border: `1px solid #${state.isFocused ? '707070' : 'e5e5e5'}`,
    '&:hover': {
      borderColor: '#707070'
    }
  }),
  menu: (provided, state) => ({
    ...provided,
    boxShadow: 'none',
    margin: '0px'
  }),
  dropdownIndicator: (provided, state) => ({
    ...provided,
    borderLeft: `1px solid #${state.isFocused ? '707070' : 'e5e5e5'}`
  }),
  option: (provided, state) => ({
    //
  })
}

function MultiSelectFetch({ selectedItems = [], placeHolder = '', title, fetchItems, openMenu = false, isMultiple = true , onSelect }) {
  const {itemsSelected, setItemsSelected} = useContext(SelectedItemsContext);
  const [menuIsOpen, setMenuIsOpen] = useState(openMenu);
  const [inputValue, setInputValue] = useState('');
  const { t } = useTranslation();

  useEffect(() => {
    setItemsSelected(mapItemsToLabelValue(selectedItems));
  }, [selectedItems])

  const GroupHeading = props => (
      <components.GroupHeading {...props} className={styles.groupHeadingStyles} />
  );

  const Option = props => {
    let val = props.data;
    
    return (
      <components.Option {...props} >
        { !isGroupSelection ? 
          <Checkbox id={val.value} label={val.label} isChecked={false} callBack={() => {/**/ }} /> : 
          <div className={styles.groupOptionsStyles}>  {val.label}  </div>
        } 
      </components.Option>
    );
  };
  
  const MultiValue = (props) => {
    return <></>
  }

  const DropdownIndicator = props => {
    const values = props.hasValue ? props.getValue() : [];

    return (
      <div className={[styles.containerIndicators].join(' ')}>
          {
            values.length <= 0 ? null :
              <div className={[styles.indicatorSelected].join(' ')}>
                {values.length <= 10 ? values.length : '+10'}
              </div>
          }
          <components.DropdownIndicator {...props}/>
      </div>
    );
  };

  const IndicatorSeparator = ({ innerProps }) => {
    return <></>;
  };

  // eslint-disable-next-line
  const [pageInfo, setPageInfo] = useState({
    totalPages: 0,
    size: 0,
    last: true,
    first: false,
    number: 0,
    nextPage: 0
  });

  const onChangeSelectedItems = (selected, {action}) => {
    setItemsSelected(selected);
    if(onSelect) {
      onSelect(selected);
    }
  }

  const onChange = (value, { action }) => {
    switch(action) {
      case 'input-change':
        setInputValue(value);
        break;
      case 'menu-close':
        onMenuOpen();
        break;
      default:
          return;
    }
  }

  const loadOptions = async (search, loadedOptions, { page }) => {

    if (search === null || search === undefined || search.trim() === '') {

      return {
        options: [],
        hasMore: false,
        additional: {
          page: 0
        }
      };
    };

    const { data, status } = await fetchItems(search, page);

    if (!(status >= 200 && status <= 299)) {
      return {
        options: loadedOptions,
        hasMore: false,
        additional: {
          page: 0
        }
      };
    }


    let { content, totalPages, last, first, size, number } = data;
    content = mapItemsToLabelValue(content);

    setPageInfo({
      totalPages: totalPages,
      last: last,
      first: first,
      size: size,
      number: number,
      nextPage: page + 1
    })

    return {
      options: content || [],
      hasMore: !last,
      additional: {
        page: page + 1
      }
    };
  };

  const onMenuOpen = () => {
    setMenuIsOpen(true);
  };

  const onMenuClose = () => {
    setMenuIsOpen(false);
  };

  return (
    <div className={styles.wrapper}>
      {title && title.trim() !== '' ? <label>{title}</label> : null}
      <AsyncPaginate
        styles={customStyles}
        loadOptions={loadOptions}
        value={itemsSelected}
        onChange={onChangeSelectedItems}
        inputValue={inputValue}
        onInputChange={onChange}
        menuIsOpen={menuIsOpen}
        onMenuOpen={onMenuOpen}
        onMenuClose={onMenuClose}
        loadOptionsOnMenuOpen={false}
        noOptionsMessage={() => t('NO_DATA_FOUND')}
        loadingMessage={() => `${t('SEARCHING')}...`}
        placeholder={placeHolder}
        isClearable={false}
        backspaceRemovesValue={false}
        closeMenuOnSelect={false}
        openMenuOnFocus={true}
        blurInputOnSelect={false}
        minMenuHeight={192}
        maxMenuHeight={192}
        menuPlacement={"auto"}
        theme={theme => ({
          ...theme,
          borderRadius: 0,
          colors: {
            ...theme.colors,
            primary: '#707070'
          },
        })}
        isMulti={isMultiple}
        components={{
          Option,
          MultiValue,
          DropdownIndicator,
          IndicatorSeparator,
          GroupHeading,
          MenuList,
        }}
        debounceTimeout={500}
        additional={{
          page: 0
        }}
      />
    </div>
  );
}

export default MultiSelectFetch;
